export default __webpack_public_path__ + "static/media/pb50.605b7fe5.png";